// template routes
import gtDefaultRoutes from "./globalTemplateRoutes/gtDefault.routes";
import gtDemoRoutes from "./globalTemplateRoutes/gtDemo.routes";
import gt2Routes from "./globalTemplateRoutes/gt2.routes";
import gt3Routes from "./globalTemplateRoutes/gt3.routes";
import adminRoutes from "./globalTemplateRoutes/admin.routes";
import appConfig from "../appconfig";

const templateRoutes = (() => {
	switch (appConfig.globalTemplateName) {
	case "gt3":
		return gt3Routes;
	case "gt2":
		return gt2Routes;
	case "gtDemo":
		return gtDemoRoutes;
	default:
		return gtDefaultRoutes;
	}
})();

const isAdmin = window.location.pathname.startsWith("/admin");

const response = () => {
	if (isAdmin) {
		return {
			...templateRoutes,
			...adminRoutes,
			routes: adminRoutes.routes.concat(...templateRoutes.routes)
		};
	}
	return templateRoutes;
};

export default response();
